const Frequency= [
    {
        id : '1',
        name : 'Once'
    },
    {
        id : '2',
        name : 'Twice a day'
    },
    {
        id : 'd',
        name : 'Daily'
    },
    {
        id : 'w',
        name : 'Weekly'
    },
    {
        id : 'bw',
        name : 'Bi-Weekly'
    },
    {
        id : 'm',
        name : 'Monthly'
    },
    {
        id : 'q',
        name : 'Quarterly'
    },
    {
        id : 'sa',
        name : 'Semi-Annually'
    },
    {
        id: 'a',
        name: 'Annually'
    },
    {
        id: 'o',
        name: 'Other'
    }
]

export default Frequency;